import { Button, Modal } from 'antd';
import { ReactComponent as DownloadIcon } from '../../assets/icons/blueDownload.svg';
import { ReactComponent as UpdateFile } from '../../assets/icons/updateFile.svg';
import { ReactComponent as DownloadFile } from '../../assets/icons/download_blue.svg';
import { UploadSingleFileModal } from 'components/newModals';
import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { formatBytes, getFullDateTimeWithSeconds } from 'utils/helpers';
import {
  checkAndHandleFinishFlag,
  downloadUploadedFile,
  openUploadedFile,
  saveTaskUpdate,
  triggerLoading,
} from 'store/forms/actions';
import {
  updateEligibility,
  updateFile,
  updateFinancial,
} from 'store/appTrack/actions';
import { useDispatch, useSelector } from 'react-redux';
import { handleSaveUpdate, isCoe, isViewformDisabled } from 'utils';
import { Tooltip } from 'components';
import { WarningModal } from 'components/layout/components';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { useNavigate } from 'react-router-dom';

const DownloadUpdateFile = ({ file, type, large }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [errors, setErrors] = useState([]);
  const [entered, setEntered] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.user);
  const id = useSelector(state => state.appTrack.apptrackDetails.activeTaskId);
  const formId = useSelector(state => state.appTrack.apptrackDetails.id);
  const activeTaskName = useSelector(
    state => state.appTrack.apptrackDetails.activeTaskName
  );
  const finishFlag = useSelector(
    state => state.appTrack.apptrackDetails.variablesIndexed?.finishFlag
  );
  const successFlag = useSelector(
    state => state.appTrack.apptrackDetails.variablesIndexed?.successFlag
  );
  const [tooltipVisible, setTooltipVisible] = useState('');
  const isVisibleTool = tooltipVisible === 'file-name-hover';
  const onOpenChange = v => setTooltipVisible(v ? 'file-name-hover' : '');

  const latestItem = file[0]?.items?.reduce((latest, item) => {
    return new Date(item.created) > new Date(latest.created) ? item : latest;
  });

  const saveData = {
    dispatch,
    saveTaskUpdate,
    taskId: id,
    formId: formId,
  };

  useEffect(() => {
    dispatch(
      checkAndHandleFinishFlag({ id, setIsErrorModalVisible, setErrors })
    );
  }, [dispatch, id]);

  return (
    <>
      {!isEmpty(file) && (
        <div
          className={
            large ? 'downloadUpdateWrapperLarge' : 'downloadUpdateWrapper'
          }
        >
          <div className={'application-file-header'}>
            {!isEmpty(file) ? file[0]?.title : ''}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <div
              style={{ display: 'flex', marginLeft: '1rem' }}
              className="mt-2"
            >
              <div className={large ? 'fileIconLarge' : 'fileIconLarge'}>
                <DownloadIcon></DownloadIcon>
              </div>
              <div className="firstHalf">
                <Tooltip
                  key={latestItem?.id}
                  title={latestItem?.name}
                  visible={isVisibleTool}
                  onOpenChange={onOpenChange}
                >
                  <div className={large ? 'fileTitleLarge' : 'fileTitle'}>
                    {!isEmpty(file) ? latestItem?.name : ''}
                  </div>
                </Tooltip>
                <div>
                  {/* <br></br> */}
                  <div className={large ? 'fileInfoLarge' : 'fileInfo'}>
                    {!isEmpty(file)
                      ? `${formatBytes(
                          latestItem?.size
                        )}, Updated: ${getFullDateTimeWithSeconds(
                          latestItem?.created
                        )}`
                      : ''}
                  </div>
                </div>
                <div className="secondPartFirstHalf">
                  <div className="documentComponentActions">
                    <div className="open-file-wrapper file-actions">
                      <a
                        className="application-open-file-text"
                        onClick={e => {
                          e.preventDefault();
                          dispatch(openUploadedFile(latestItem));
                        }}
                        target={'_blank'}
                      >
                        Άνοιγμα
                      </a>
                    </div>
                    <div className="file-actions">
                      <a
                        className="application-download-file-text"
                        style={{ marginLeft: '-1.5rem' }}
                        onClick={e => {
                          e.preventDefault();
                          dispatch(downloadUploadedFile(latestItem));
                        }}
                        download={latestItem?.name}
                      >
                        <DownloadFile /> Download
                      </a>
                    </div>
                    {!isViewformDisabled(window.location.pathname) &&
                      activeTaskName == 'task.name.application_evaluation' &&
                      isCoe(user?.groups) && (
                        // activeTaskName == "task.name.application_evaluated" && isBeneficiary(user?.groups))
                        <Button
                          disabled={finishFlag === false}
                          className="updateFileButton"
                          onClick={() => setIsVisible(true)}
                        >
                          <UpdateFile></UpdateFile>
                          <span className="updateFileSpan">Ενημέρωση</span>
                        </Button>
                      )}
                  </div>
                </div>
              </div>
            </div>

            <WarningModal
              isVisible={isErrorModalVisible && isCoe(user?.groups)}
              setVisible={setIsErrorModalVisible}
              // Icon={icon}
              // closable={true}
              //   title={title}
              // handleConfirm={() => setVisible(false)}
              onCancel={() => {
                setIsErrorModalVisible(false);
                setErrors([]);
              }}
              title={'Σφάλμα κατά τη μεταφόρτωση'}
              message={
                typeof errors == 'string'
                  ? errors
                  : errors?.map((msg, i) => (
                      <div
                        key={i}
                        style={{ marginBottom: '8px', fontSize: '14px' }}
                      >
                        • {msg.errorLabel}
                      </div>
                    ))
              }
              width={400}
              footer={[
                <Button
                  type={'default'}
                  style={{ width: '100%' }}
                  onClick={() => {
                    setIsErrorModalVisible(false);
                    setErrors([]);
                  }}
                >
                  Κλείσιμο
                </Button>,
              ]}
              className={'invalid-modal custom-modal warning-modal'}
            >
              <div className="custom-modal__header">
                <WarningRed />
                <span>{''}</span>
              </div>
              <div className="custom-modal__body">{}</div>
            </WarningModal>

            <UploadSingleFileModal
              title={!isEmpty(file) ? file[0]?.title : ''}
              setIsVisible={setIsVisible}
              files={file[0]?.items}
              fileAccepts={''}
              isVisible={isVisible}
              fileCode={
                !isEmpty(file)
                  ? file[0]?.items[file[0]?.items.length - 1]?.field
                  : ''
              }
              handleSubmit={payload => {
                dispatch(triggerLoading(true));
                if (type == 'business') {
                  dispatch(updateFile(id, payload)).then(result => {
                    if (result.success) {
                      const field = latestItem?.field;

                      const dataToSave = {
                        ...saveData,
                        documents: {
                          ...(field ? { [field]: result.data } : {}),
                        },
                      };
                      handleSaveUpdate(dataToSave);
                    }
                  });
                } else if (type == 'eligibility') {
                  dispatch(updateEligibility(id, payload, navigate)).then(
                    result => {
                      if (result.success == true) {
                        const field = latestItem?.field;

                        // const dataToSave = {
                        // ...saveData,
                        // documents: {
                        // ...(field ? { [field]: result.data } : {})
                        // }
                        // };
                        // console.log("dataToSave", dataToSave)
                        // handleSaveUpdate(dataToSave);
                      } else if (result.success == false) {
                        setErrors(
                          'Παρουσιάστηκε σφάλμα κατα τη μεταφόρτωση του αρχείου. Παρακαλώ προσπαθήστε ξανά.'
                        );
                        setIsErrorModalVisible(true);
                      }
                    }
                  );
                } else if (type == 'financial') {
                  dispatch(updateFinancial(id, payload, navigate)).then(
                    result => {
                      if (result.success == true) {
                        const field = latestItem?.field;

                        // const dataToSave = {
                        // ...saveData,
                        // documents: {
                        // ...(field ? { [field]: result.data } : {})
                        // }
                        // };
                        // console.log("dataToSave", dataToSave)
                        // handleSaveUpdate(dataToSave);
                      } else if (result.success == false) {
                        setErrors(
                          'Παρουσιάστηκε σφάλμα κατα τη μεταφόρτωση του αρχείου. Παρακαλώ προσπαθήστε ξανά.'
                        );
                        setIsErrorModalVisible(true);
                      }
                    }
                  );
                }
              }}
            ></UploadSingleFileModal>
          </div>
          <div className="secondHalf"></div>
        </div>
      )}
    </>
  );
};

export default DownloadUpdateFile;
